export const LoginGuard = (to, from, next) => {
  if (localStorage.getItem("access_token")) return next({ name: "UserList" });

  next();
};
